import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCycleGlyphSecondary from './svgs/CycleGlyphSecondary.js';
import SvgCycleGlyph from './svgs/CycleGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cycleGlyph = (props => useIcon(SvgCycleGlyph, SvgCycleGlyphSecondary, props));

export { cycleGlyph as default };
